import { Box, Text } from '@chakra-ui/react'
import React from 'react'


export const InsuranceInfoItem = ({
  children, label, value,
}: {
  children?: React.ReactNode;
  label: string;
  value?: string | number | React.ReactNode;
}) => {
  return (
    <Box sx={{ display: 'grid', gap: 1, alignContent: 'start', justifyItems: 'start' }}>
      <Text sx={{ fontSize: 'sm', fontWeight: 'semibold', lineHeight: 'body' }}>{label}</Text>
      {value && (
        <Box sx={{ color: 'primary.400', fontSize: 'lg', fontWeight: 'medium' }}>{value}</Box>
      )}

      {children && children}
    </Box>
  )
}
